export default "__VITE_ASSET__fb1c7cf4__"